import lottie from 'lottie-web'
import gsap from 'gsap'

export const preloader = () => {

	const el = document.querySelector('[data-animation="preloader"]')

	if (!el) return

	let icon = lottie.loadAnimation({
		container: el,
		renderer: 'svg',
		loop: false,
		autoplay: false,
		path: '/json/preloader.json',
	})

	icon.play()
}

export default () => { }